import { createPortal } from "react-dom";

/** Rend les modales dans document.body pour un centrage viewport correct (évite transform parent). */
export default function ModalPortal({ children }) {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
}
